import React, { useState, useRef } from "react";
import backgroundImage from '../../src/assets/images/blogbanner.png';
import AppoinmentModal from "./AppoinmnetModal";

const BlogBanner = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
        const stickyButtonRef = useRef(null);
    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    return (
        <div>
            <div
                className="bg-cover bg-center h-screen w-full flex justify-center items-center flex-col"
                style={{ backgroundImage: `url(${backgroundImage})` }}
            >
            </div>
            <div>
                <button
                    ref={stickyButtonRef}
                    type="button"
                    className="sticky-button bg-[#7c517e] text-white text-sm px-3 py-1 md:px-4 md:py-2 mt-2 md:mt-0 w-full cursor-pointer md:w-auto"
                    onClick={openModal}
                >
                    BOOK APPOINTMENT
                </button>

                <AppoinmentModal isOpen={isModalOpen} onClose={closeModal} />
            </div>
            <section
                className="flex justify-center items-center text-center pt-80 pb-80"
                style={{
                    background: 'linear-gradient(to right, #fffdf7, #fffbef, #f5f5f5, #f9faf6)',
                    minHeight: '400px'
                }}
            >
                <div className='custom-padding xl-screen-padding'>
                    <h2 className="text-3xl font-semibold  mb-8 client-text">
                        Your Personalized <span className="text-[#8f762c]">Nutrition</span> Hub
                    </h2>
                    <p className="text-md mb-2 text-[#6e777e] font-lato">Welcome to the Nutrillion Blog, where science meets well-being.</p>
                    <p className="text-md mb-2 text-[#6e777e] font-lato">Explore expert insights, advanced research, and personalized strategies to optimize your health.</p>
                    <p className="text-md text-[#6e777e] font-lato">Stay informed, stay empowered!</p>
                </div>
            </section>
        </div>
    );
};

export default BlogBanner;
